import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib';

export function AppTooltip({
  classNames = { root: 'app_tooltip app_tooltip--auto-width' },
  placement = 'top',
  children,
  ...props
}: TooltipProps) {
  return (
    <Tooltip classNames={classNames} placement={placement} {...props}>
      <span>{children}</span>
    </Tooltip>
  );
}
